import React from 'react';
import Retry from './Retry/Retry';
import Loader from '../../../components/Loader/Loader';

export default function Loading(props) {
  if (props.isLoading) {
    const currentHash = window.location.hash.replace('#', '') || '/';
    const authVariant = currentHash === '/' || currentHash === '/register';

    return <Loader variant={authVariant ? 'auth' : 'page'} />;
  }

  if (props.error) {
    return (
      <Retry onClick={props.retry} />
    );
  }
  return null;
}
